/* Package JSON Import will be here */
import React, { useState } from "react";
import { useSelector } from 'react-redux';
import { filter } from "lodash";
import { Row, Col, Badge } from "antd";
/* Package JSON Import will be here */

/* Project Import will be here */
import Constants from "utilities/appConstants";
import AttrFilterTemplate from "./AttrFilterTemplate";
/* Project Import will be here */

const MobileAttrFilterContent = (props) => {
    const { attrFilter } = useSelector((state) => ({
        attrFilter: state.attrFilter
    }));

    const [selectedAttrId, setSelectedAttrId] = useState(attrFilter.data[0].AttrId);

    const onSelectAttr = (attrId) => {
        setSelectedAttrId(attrId);
    }

    const attrListCss = (attrId) => {
        let css = "p-2";
        if (selectedAttrId !== attrId)
            css += " inactive-attr-color";
        else
            css += " active-attr-color";

        return css;
    }

    const getSelectedAttr = (attrId) => {
        const selectedAttr = filter(attrFilter.selectedAttrFilter, (o) => {
            return o.AttrId === attrId;
        })[0];

        return selectedAttr;
    }

    const checkForSelectedAttr = (attrId) => {
        const selectedAttrData = getSelectedAttr(attrId);

        if (selectedAttrData !== undefined)
            return true;
        else
            return false;
    }

    return (
        <React.Fragment>
            <Row>
                <Col span={10} className="text-center attr-filter-list">
                    {attrFilter.data.map((item) => {
                        return (
                            <div key={item.AttrId}
                                onClick={() => onSelectAttr(item.AttrId)}
                                className={attrListCss(item.AttrId)}
                            >
                                <Badge dot={checkForSelectedAttr(item.AttrId)} className="responsive-font-size break-all">
                                    {item.AttrName}
                                </Badge>
                            </div>
                        )
                    })}
                </Col>
                <Col span={14} className="attr-filter-value-list">
                    <AttrFilterTemplate attrId={selectedAttrId} pageType={Constants.ATTR_MOBILE} />
                </Col>
            </Row>
        </React.Fragment>
    );
}

export default MobileAttrFilterContent;